export default {
  namespaced: true,
  state: {
    isCartMaxLimit: false,
    isCurrentCartRefresh: false,
    isCloseBuyingOptionsPopup: 0
  },
  mutations: {
    setCartMaxLimitStatus(state, status) {
      state.isCartMaxLimit = status;
    },
    setCurrentCartRefreshStatus(state, status) {
      state.isCurrentCartRefresh = status;
    },
    setCloseBuyingOptionsPopup(state, status) {
      state.isCloseBuyingOptionsPopup = status;
    }
  }
};
